import type { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
  IconCarrierListWarning,
  IconCheck,
  IconInfoOutlined,
} from "design-components";
import type { DashboardOverviewCell } from "../types";

export interface DashboardBookingOverviewProps {
  cells: DashboardOverviewCell[];
}

export const DashboardBookingOverview: FC<DashboardBookingOverviewProps> = ({ cells }) => (
  <Box className="operator-dashboard__card operator-dashboard__card--booking-overview">
    <Typography component="h2" variant="subtitle1" className="operator-dashboard__card-title">
      Booking overview
    </Typography>
    <Box className="operator-dashboard__overview-grid">
      {cells.map((c) => (
        <Box key={c.status} className="operator-dashboard__overview-cell">
          <Typography component="p" className="operator-dashboard__overview-count">
            {c.count}
          </Typography>
          <Box
            className={`operator-dashboard__overview-icon-ring operator-dashboard__overview-icon-ring--${c.icon}`}
            aria-hidden
          >
            <OverviewIcon icon={c.icon} />
          </Box>
          <Typography component="p" className="operator-dashboard__overview-label">
            {c.label}
          </Typography>
        </Box>
      ))}
    </Box>
    <Link to="/bookings" className="operator-dashboard__footer-link">
      View all bookings
    </Link>
  </Box>
);

function OverviewIcon({ icon }: { icon: DashboardOverviewCell["icon"] }): ReactNode {
  const glyph = 22;
  switch (icon) {
    case "warning":
      return (
        <IconCarrierListWarning
          aria-hidden
          size={glyph}
          className="operator-dashboard__overview-icon-glyph operator-dashboard__overview-icon-glyph--warning"
        />
      );
    case "info":
      return (
        <IconInfoOutlined
          aria-hidden
          size={glyph}
          className="operator-dashboard__overview-icon-glyph operator-dashboard__overview-icon-glyph--info"
        />
      );
    case "success":
      return (
        <IconCheck
          aria-hidden
          size={glyph}
          className="operator-dashboard__overview-icon-glyph operator-dashboard__overview-icon-glyph--success"
        />
      );
    default:
      return (
        <IconCheck
          aria-hidden
          size={glyph}
          className="operator-dashboard__overview-icon-glyph operator-dashboard__overview-icon-glyph--neutral"
        />
      );
  }
}